import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconModule } from '@hglobal/fin-ui';

import { Account } from '@iw/core/entities';
import { IwDecimalPipe, MaskBalancePipe } from '@iw/core/pipes';

import { CardViewSize } from '../card-view.model';

@Component({
  selector: 'iw-treasurer-wallet',
  imports: [IconModule, NgClass, IwDecimalPipe, MaskBalancePipe],
  templateUrl: './treasurer-wallet.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
})
export class TreasurerWalletComponent {
  readonly wallet = input<Account>();
  readonly size = input<CardViewSize>();
  readonly iconSize = input<Record<CardViewSize, number>>();
  readonly currentWallet = input<Account>();
  readonly useBalanceMask = input<boolean>(false);
}
